import React, { useCallback, useEffect, useState } from "react";
import HeadingComponent from "../../components/HeadingComponent";
import { parseFirebaseDateTime } from "../../utils/helper";
import { Row, Col, DatePicker, Input, Select } from "antd";
import { useSelector } from "react-redux";
import { rangePresets } from "./constants";
import dayjs from "dayjs";
import "./index.css";
import { getHistories, getHistoryByMsg } from "./APIs/firebaseVisitorsHistory";
import PropertiesFilter from "../../components/PropertiesFilter";
import CustomTable from "../../components/CustomTable";
import { formatDistance } from "date-fns";
import VisitorHistoryDrawer from "./VisitorHistoryDrawer";

const { RangePicker } = DatePicker;
const { Search } = Input;

const ChatHistory = () => {
  const selectedProperties = useSelector(
    (state) => state.properties.selectedProperties
  );
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(7, "day"),
    dayjs(),
  ]);
  const [historyType, setHistoryType] = useState("engaged");
  const [histories, setHistories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [drawerContent, setDrawerContent] = useState();
  const [showDrawer, setShowDrawer] = useState(false);
  const [allHistories, setAllHistories] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20, // Initial page size
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, { propertyId, name, visitor_default }) => {
        return <>{name ? name : visitor_default}</>;
      },
      columnSearch: true,
    },
    {
      title: "IP Address",
      dataIndex: "ipAddress",
    },
    {
      title: "Landing Page",
      dataIndex: "landingPage",
      width: 300,
      ellipsis: true,
      columnSearch: true,

      render: (landingPage) => (
        <>
          {landingPage ? (
            <a
              href={landingPage}
              rel="noreferrer"
              target="_blank"
              title={landingPage}
            >
              {landingPage}
            </a>
          ) : (
            "-"
          )}
        </>
      ),
    },
    {
      title: "Location",
      dataIndex: "location",
      render: (text, record) => {
        let location = "";
        if (record?.city) location += `${record?.city}`;
        if (record?.stateProv) location += `, ${record?.stateProv}`;
        if (record?.countryName) location += `, ${record?.countryName}`;
        return <span>{location}</span>;
      },
    },
    {
      title: "Duration",
      width: 140,

      render: (text, { createdAt, endedAt }) => {
        return (
          <span>
            {createdAt && endedAt
              ? formatDistance(createdAt.toDate(), endedAt.toDate())
              : "-"}
          </span>
        );
      },
    },
    {
      title: "Messages Count",
      dataIndex: "messagesCount",
      width: 100,
      render: (text, record) => {
        return (
          <span>{record?.messagesCount ? record.messagesCount : "-"}</span>
        );
      },
    },
    {
      title: "Created",
      dataIndex: "created",
      render: (text, record) => {
        let createdAt =
          record?.engaged === false
            ? record.historyCreatedAt
            : record?.createdAt;
        return <span>{parseFirebaseDateTime(createdAt)}</span>;
      },
    },
  ];

  const fetchHistories = async () => {
    try {
      setLoading(true);
      let response = await getHistories(
        selectedProperties,
        dateRange,
        historyType
      );
      setHistories(response);
      setAllHistories(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedProperties.length > 0) {
      fetchHistories();
    }
  }, [selectedProperties, dateRange, historyType]);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
  };

  const disabledDate = (current) => {
    return current && current > new Date();
  };

  const onRangeChange = (dates) => {
    if (dates) {
      setDateRange(dates);
    } else {
      console.log("Clear");
    }
  };

  const displayModal = () => {
    setShowDrawer(true);
  };

  const hideModalCallback = useCallback(() => {
    setDrawerContent();
    setShowDrawer(false);
  }, []);

  const onClickRow = async (record) => {
    setDrawerContent(record);
    displayModal();
  };

  const onSearch = async (value) => {
    let msg = value.trim();
    let emptyValueCheck = msg === "" || msg === undefined;
    setLoading(true);
    if (!emptyValueCheck) {
      let results = await getHistoryByMsg(allHistories, msg);
      setHistories(results);
      setLoading(false);
    } else {
      setHistories(allHistories);
      setLoading(false);
    }
  };

  const handlePageChange = (pagination) => {
    console.log("pagination", pagination);
    setPagination(pagination);
  };

  const onChangeHistoryType = (e) => {
    setHistoryType(e);
  };
  return (
    <>
      {/* <Row gutter={[8, 0]} className="header_row">
        <Col xs={24} sm={5}>
          <Search
            allowClear
            placeholder="Search messages.. "
            onSearch={onSearch}
            enterButton
          />
        </Col>
        <Col xs={24} sm={4}>
          <RangePicker
            disabledDate={disabledDate}
            style={{ marginRight: 10, width: "100%" }}
            defaultValue={dateRange}
            presets={rangePresets}
            onChange={onRangeChange}
            format="MMM, DD, YYYY"
          />
        </Col>
        <Col xs={24} sm={12}>
          <PropertiesFilter />
        </Col>
      </Row> */}
      <Row gutter={[4, 16]} className="history-head">
        <Col lg={4} sm={8} xs={12}>
          <HeadingComponent text="Visitor History" />
        </Col>
        <Col lg={6} sm={8} xs={12}>
          {/* <Search
            allowClear
            placeholder={`${
              searchhBy === "messages"
                ? `Search in messages..`
                : `Search by visitor..`
            }`}
            onSearch={onSearch}
            enterButton
          />
          <Radio.Group
            onChange={handleSearchChange}
            value={searchhBy}
            className="mt-2"
          >
            <span className="mr-2 bold"> Search In:</span>
            <Radio value="messages">Messages</Radio>
            <Radio value="visitor">Visitor</Radio>
          </Radio.Group> */}
          <Search
            allowClear
            placeholder="Search messages.. "
            onSearch={onSearch}
            enterButton
          />
        </Col>
        <Col lg={3} sm={8} xs={12}>
          <Select
            defaultValue="engaged"
            style={{
              width: "100%",
            }}
            onChange={(e) => onChangeHistoryType(e)}
            options={[
              {
                value: "all",
                label: "All ",
              },
              {
                value: "engaged",
                label: "Engaged",
              },
              {
                value: "missed",
                label: "Missed",
              },
              {
                value: "conversed",
                label: "Conversed",
              },

              {
                value: "notengaged",
                label: "Not Engaged",
              },
            ]}
          />
        </Col>
        <Col lg={6} sm={12} xs={12}>
          <PropertiesFilter />
        </Col>
        <Col lg={5} sm={12} xs={12}>
          <RangePicker
            disabledDate={disabledDate}
            style={{ marginRight: 10, width: "100%" }}
            defaultValue={dateRange}
            presets={rangePresets}
            onChange={onRangeChange}
            format="MMM, DD, YYYY"
          />
        </Col>
      </Row>

      <br />

      <CustomTable
        pagination={pagination}
        handlePageChange={handlePageChange}
        dataSource={histories}
        columns={columns}
        loading={loading}
        handleTableChange={handleTableChange}
        onClickRow={onClickRow}
      />

      <VisitorHistoryDrawer
        histories={histories}
        showDrawer={showDrawer}
        hideModal={hideModalCallback}
        modalData={drawerContent}
        setDrawerContent={setDrawerContent}
      />
    </>
  );
};

export default ChatHistory;
